import styled, { css } from 'styled-components'
import { theme, AVAILABLE_BRANDS } from 'styles/theme'
import bgCloud from 'assets/svg/bg_cloud.svg'
import VideoPlayer from '../VideoPlayer'

export const BackgroundVideo = styled(VideoPlayer)`
  position: fixed;
  right: 50%;
  bottom: 50%;
  transform: translate(50%, 50%);
  min-width: 100%;
  min-height: 100%;
  z-index: 0;
  opacity: 1;
  max-width: 100vw;
`

export const BackgroundImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  ${({ src, theme: { color } }) => {
    if (src) {
      return css`
        opacity: 0.4;
        background-image: url(${src});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      `
    } else if (color === AVAILABLE_BRANDS.CLOUD_DARK) {
      return css`
        background-image: url(${bgCloud});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      `
    } else {
      return css`
        background-color: ${theme.colors.white};
      `
    }
  }}

  opacity: 1;
`
